export default "__VITE_ASSET__DaNT0$7D__"